import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { HelperMessage } from './styled'

interface FormHelperMessageProps {
  message?: React.ReactNode
}

export const FormHelperMessage: React.FC<FormHelperMessageProps> = ({
  message,
}) => {
  if (!message) return null

  return (
    <HelperMessage>
      <FontAwesomeIcon icon={faInfoCircle} aria-hidden />
      <span>{message}</span>
    </HelperMessage>
  )
}

export default FormHelperMessage
